<template>
    <views class="faq-item">
        <views class="faq-q">
            <views class="icon">
                <images :src="qIcon"></images>
            </views>
            <views class="title">{{ item.question }}</views>
        </views>
        <views
            :class="{'all': isOpen}"
            class="faq-a">
            <views class="icon">
                <images :src="aIcon"></images>
            </views>
            <views class="title">{{ item.answer }}</views>
        </views>
        <views v-show="!isOpen && item.answer.length > 70" class="open" @click="toggle">
            <images :src="openIcon"></images>
        </views>
        <views v-show="isOpen" class="close" @click="toggle">
            <images :src="closeIcon"></images>
        </views>
    </views>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isOpen: false,
            aIcon: require('@/assets/images/a.png'),
            qIcon: require('@/assets/images/q.png'),
            openIcon: require('@/assets/images/qa_open.png'),
            closeIcon: require('@/assets/images/qa_close.png')
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
